"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.propTypes = void 0;

var _reactDesc = require("react-desc");

var _designTokens = _interopRequireDefault(require("@decisiv/design-tokens"));

var _propTypes = require("@decisiv/prop-types");

var _spacingSchema = require("../../modifiers/spacingSchema");

var _withColors = require("./withColors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var schema = (0, _reactDesc.describe)({
  displayName: 'Typography'
});
var typographyWeight = _designTokens.default.typography.weight;

var propTypeDocs = _objectSpread({
  color: _reactDesc.PropTypes.oneOf(_withColors.typographyColorKeys).description('Sets the color of the typography component. Can not be used with `shade` prop. If both are applied, color will win. Not based on theme.')
}, (0, _spacingSchema.makeSpacingSchemaPropTypes)(), {
  shade: _reactDesc.PropTypes.oneOf([0, 1, 2]).description('Sets the greyscale shade of the typography component. In light mode, a higher number means a lighter text color.').defaultValue(0),
  truncate: _reactDesc.PropTypes.bool.description('Forces the text to a single line and truncates. A width for the component must be defined.'),
  weight: _reactDesc.PropTypes.oneOf(Object.keys(typographyWeight.alias)).description('Sets the font weight of the component according to the mapping in the Design Tokens.')
});

schema.propTypes = propTypeDocs;

var propTypes = _objectSpread({}, propTypeDocs, {
  color: (0, _propTypes.forbiddenIf)(_reactDesc.PropTypes.oneOf(_withColors.typographyColorKeys), function (_ref) {
    var shade = _ref.shade;
    return !!shade;
  }),
  shade: (0, _propTypes.forbiddenIf)(_reactDesc.PropTypes.oneOf(_withColors.typographyShadeKeys), function (_ref2) {
    var color = _ref2.color;
    return !!color;
  })
});

exports.propTypes = propTypes;
var _default = schema;
exports.default = _default;